var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImdbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510 3740 c-247 -33 -434 -198 -495 -435 -23 -90 -23 -1602 0 -1690 54 -207 222 -371 428 -420 94 -22 4140 -22 4234 0 206 49 374 213 428 420 23 88 23 1600 0 1690 -52 204 -202 358 -411 421 -56 18 -164 19 -2094 20 -1119 1 -2060 -2 -2090 -6z m630 -1235 l0 -705 -165 0 -165 0 0 705 0 705 165 0 165 0 0 -705z m638 528 c17 -98 44 -249 59 -335 15 -87 30 -158 33 -158 4 0 24 151 45 335 l39 335 233 0 233 0 0 -705 0 -705 -145 0 -145 0 -1 393 c0 215 -4 381 -8 367 -4 -14 -37 -191 -72 -393 l-64 -368 -105 3 -105 3 -66 375 c-36 206 -68 382 -71 390 -4 8 -7 -162 -7 -377 l-1 -393 -155 0 -155 0 0 705 0 705 213 0 214 0 31 -177z m1443 156 c74 -16 143 -52 169 -89 48 -67 50 -93 50 -585 0 -516 -1 -525 -68 -592 -19 -20 -56 -45 -81 -56 -88 -39 -154 -46 -428 -47 l-263 0 0 697 0 696 283 -6 c156 -4 308 -12 338 -18z m669 -139 c0 -88 2 -160 4 -160 3 0 25 14 50 30 50 34 101 54 163 65 96 16 208 -56 231 -148 15 -58 17 -855 2 -907 -5 -20 -26 -51 -45 -70 -35 -34 -38 -35 -128 -38 -80 -3 -105 1 -191 27 -54 17 -102 31 -107 31 -4 0 -14 -18 -20 -40 l-12 -40 -144 0 -143 0 0 705 0 705 170 0 170 0 0 -160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2930 2520 l0 -480 23 0 c43 1 102 19 114 36 16 23 19 854 3 884 -11 20 -66 40 -112 40 l-28 0 0 -480z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3920 2801 c-11 -22 -15 -715 -4 -770 8 -39 36 -56 64 -41 19 10 20 21 20 408 0 296 -3 401 -12 410 -18 18 -56 14 -68 -7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImdbIcon);
export default __webpack_public_path__ + "static/media/imdb-icon.6902e97c067bf9ae3ba1c08329902488.svg";
export { ForwardRef as ReactComponent };